import { COLS_BAR_HEIGHT, ROWS_BAR_WIDTH } from './consts';
import { setSelection, useAllSelected } from './selection';
import { RectRange } from '@/model/range';
import clsx from 'clsx';

export function CornerView() {
  const selected = useAllSelected();

  return (
    <div
      className={clsx(
        'sticky top-0 left-0 border-r-3 border-b-3 border-black/50',
        selected ? 'bg-red-800' : 'bg-gray-100',
      )}
      style={{ width: ROWS_BAR_WIDTH, height: COLS_BAR_HEIGHT }}
      onMouseDown={() => setSelection(RectRange.all())}
    ></div>
  );
}
